import React, { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import axios from "axios";

const API_BASE = "https://app.commercialcleaningleadsforyou.com";
const STORAGE_KEY = "chat_user_email";
const STORAGE_EXPIRY = 90 * 24 * 60 * 60 * 1000; // 90 days

const ChatButton = ({ onClick, className = "" }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [hasConversation, setHasConversation] = useState(false);

  useEffect(() => {
    // Check for saved email and conversation
    const loadChatState = async () => {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
          const { email: savedEmail, timestamp } = JSON.parse(saved);
          const now = Date.now();
          if (now - timestamp < STORAGE_EXPIRY) {
            // Check for unread messages
            await checkUnreadCount(savedEmail);
          }
        } else {
          // Show default unread indicator even if no email saved
          // This helps users know chat is available
          setHasConversation(false);
          setUnreadCount(0);
        }
      } catch (error) {
        console.error("Error loading chat state:", error);
      }
    };
    
    loadChatState();
    
    // Poll for updates every 30 seconds
    const interval = setInterval(() => {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        try {
          const { email: savedEmail, timestamp } = JSON.parse(saved);
          const now = Date.now();
          if (now - timestamp < STORAGE_EXPIRY) {
            checkUnreadCount(savedEmail);
          }
        } catch (error) {
          console.error("Error polling chat state:", error);
        }
      }
    }, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const checkUnreadCount = async (email) => {
    try {
      const response = await axios.get(
        `${API_BASE}/api/chat/conversation/${encodeURIComponent(email)}`
      );
      if (response.data?.data && response.data.data.length > 0) {
        setHasConversation(true);
        const messages = response.data.data;
        const lastReadKey = `chat_last_read_${email}`;
        const savedLastRead = localStorage.getItem(lastReadKey);
        const savedLastReadId = savedLastRead ? parseInt(savedLastRead, 10) : null;
        
        // Count unread admin replies
        const unreadReplies = messages.filter(
          (msg) => msg.admin_reply && msg.admin_replied_at && (!savedLastReadId || msg.id > savedLastReadId)
        );
        setUnreadCount(unreadReplies.length);
      } else {
        setHasConversation(false);
        setUnreadCount(0);
      }
    } catch (error) {
      console.error("Error checking unread count:", error);
      // On error, still show the button but without unread count
      setHasConversation(false);
      setUnreadCount(0);
    }
  };

  return (
    // <button
    //   onClick={onClick}
    //   className={`group relative ${className}`}
    //   aria-label="Chat"
    // >
    //   <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#26A94A] shadow-lg ring-1 ring-black/10 transition-transform group-hover:scale-110 active:scale-95 relative">
    //     <MessageCircle size={20} className="text-white" />
    //     {unreadCount > 0 && (
    //       <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full text-xs flex items-center justify-center font-semibold text-white animate-pulse">
    //         {unreadCount}
    //       </span>
    //     )}
    //     {hasConversation && unreadCount === 0 && (
    //       <span className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full"></span>
    //     )}
    //   </div>
    // </button>
<></>
  );
};

export default ChatButton;

